import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { useRouter } from '@flipster/i18n/routing';
import { TextButton } from '@flipster/react/design-system/text-button';
import GiftIcon from '@flipster/react/icon/generated/GiftIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import Num, { numberFormatter } from '@flipster/utils/num';
import webviewHandler from '@flipster/utils/webview-handler';

import { dailyCheckInBunja, dailyCheckInMinDays } from './state';

export const NoticeBanner = () => {
  const { dailyCheckInAtom, dailyCheckInSuccessAtom } = useBunja(dailyCheckInBunja);
  const dailyCheckIn = useAtomValue(dailyCheckInAtom);
  const dailyCheckInSuccess = useAtomValue(dailyCheckInSuccessAtom);
  const router = useRouter();

  if (!dailyCheckIn) return null;

  const getMessage = () => {
    const requiredVolume = Num(dailyCheckIn.minVolume).minus(dailyCheckIn.currentVolume).toString();

    if (dailyCheckIn.achievedMinVolume) {
      if (dailyCheckInSuccess.isAllSuccess)
        return {
          label: <FormattedMessage id='Competition.r251218.Eligible_rewards_congrats' />,
          tradeNow: false,
        };
      if (dailyCheckInSuccess.successCount >= dailyCheckInMinDays)
        return {
          label: <FormattedMessage id='Competition.r251218.Eligible_rewards_come_back_tomorrow_bigger_reward' />,
          tradeNow: false,
        };
      return {
        label: (
          <FormattedMessage
            id='Competition.r251218.Not_yet_eligible_rewards_check_least_count_days'
            values={{ count: dailyCheckInMinDays }}
          />
        ),
        tradeNow: true,
      };
    } else {
      if (dailyCheckInSuccess.successCount >= dailyCheckInMinDays)
        return {
          label: (
            <FormattedMessage
              id='Competition.r251218.Not_yet_eligible_rewards_trade_volume_more_unlock_rewards'
              values={{ volume: `$${numberFormatter(requiredVolume, { precision: 0 })}` }}
            />
          ),
          tradeNow: true,
        };
      // 2일 이상 체크인 했지만 최소 체크인 일수를 채우지 못했는데 최소 체크인 일수를 채울 수 있는 만큼의 시간이 남아있다면
      if (dailyCheckInSuccess.canAchieveMinWithinPeriod)
        return {
          label: (
            <FormattedMessage
              id='Competition.r251218.Not_yet_eligible_rewards_trade_volume_more_unlock_rewards'
              values={{ volume: `$${numberFormatter(requiredVolume, { precision: 0 })}` }}
            />
          ),
          tradeNow: true,
        };
      return {
        label: <FormattedMessage id='Competition.r251218.Not_eligible_events_rewards_try_again_next_time' />,
        tradeNow: false,
      };
    }
  };

  return (
    <section
      className={hstack({
        py: 16,
        px: 24,
        w: '100%',
        rounded: { base: 12, tablet: 16 },
        bg: 'background.default.level-1',
        gap: 10,
      })}
    >
      <GiftIcon size={24} color={token('colors.content.accent.new')} />
      <div
        className={stack({
          flex: 1,
          gap: { base: 0, tablet: 4 },
          flexDirection: { base: 'column', tablet: 'row' },
          alignItems: { base: 'flex-start', tablet: 'center' },
        })}
      >
        <p
          className={css({
            textStyle: 'Text/M/Regular',
            color: 'content.default.level-5',
            whiteSpace: 'pre-line',
            textAlign: 'left',
          })}
        >
          {getMessage().label}
        </p>
        {getMessage().tradeNow && (
          <TextButton
            color='neutral'
            size='medium'
            onClick={() => {
              webviewHandler.postMessage({ action: 'link', params: { page: 'trade/latest' } }, () =>
                router.push('/trade/latest'),
              );
            }}
            label={<FormattedMessage id='Competition.r251215.Trade_now' />}
          />
        )}
      </div>
    </section>
  );
};
